export default {
  setVisitors(state, data) {
    state.visitors = data;
  },

  setBranches(state, data) {
    state.branches = data;
  },

  setBranch(state, data) {
    state.branch = data;
  },

  setBranchCode(state, data) {
    state.branchCode = data;
  },

  setFiscalYears(state, data) {
    state.fiscalYears = data;
  },
  setFiscalYear(state, data) {
    state.fiscalYear = data;
  },

  setUsers(state, data) {
    state.users = data;
  },
  setUser(state, data) {
    state.user = data;
  },
  setUserId(state, data) {
    state.userId = data;
  },

  setUsersGroup(state, data) {
    state.usersGroup = data;
  },
  setUserGroup(state, data) {
    state.userGroup = data;
  },

  setRoles(state, data) {
    state.roles = data;
  },
  setRolePermission(state, data) {
    state.rolePermission = data;
  },
  setUserRolePermission(state, data) {
    state.userRolePermission = data;
  },

  setBranchYears(state, data) {
    state.branchYears = data;
  },

  setCountries(state, data) {
    state.countries = data;
  },
  setCountryMaxCode(state, data) {
    state.countryMaxCode = data;
  },

  setProvinces(state, data) {
    state.provinces = data;
  },
  setProvinceMaxCode(state, data) {
    state.provinceMaxCode = data;
  },

  setCities(state, data) {
    state.cities = data;
  },
  setCityMaxCode(state, data) {
    state.cityMaxCode = data;
  },

  setRegion(state, data) {
    state.region = data;
  },
  setRegionMaxCode(state, data) {
    state.regionMaxCode = data;
  },

  setPersonGroups(state, data) {
    state.personGroups = data;
  },
  setPersonGroupCode(state, data) {
    state.personGroupCode = data;
  },

  setPersons(state, data) {
    state.persons = data;
  },
  setPerson(state, data) {
    state.person = data;
  },
  setPersonBySearch(state, data) {
    state.personBySearch = data;
  },
  setPersonNavigation(state, data) {
    state.personNavigation = data;
  },
  setPersonIsLegal(state, data) {
    state.personIsLegal = data;
  },
  setPersonEmployeeGroup(state, data) {
    state.personEmployeeGroup = data;
  },
  setIsPersonGenralGroup(state, data) {
    state.isPersonGenralGroup = data;
  },

  setPersonId(state, data) {
    state.personId = data;
  },

  setPersonPosition(state, data) {
    state.personPosition = data;
  },

  setPersonFinancialInfo(state, data) {
    state.personFinancialInfo = data;
  },
  setPersonFinancialInfoCode(state, data) {
    state.personFinancialInfoCode = data;
  },

  setPersonTaxFiles(state, data) {
    state.personTaxFiles = data;
  },
  setPersonTaxFile(state, data) {
    state.personTaxFile = data;
  },
  setPersonTaxFilesCode(state, data) {
    state.personTaxFilesCode = data;
  },

  setPersonCode(state, data) {
    state.personCode = data;
  },

  setPrefix(state, data) {
    state.prefix = data;
  },
  setPrefixCode(state, data) {
    state.prefixCode = data;
  },

  setPersonContact(state, data) {
    state.personContact = data;
  },

  setSbuTree(state, data) {
    state.sbuTree = data;
  },

  setSbuList(state, data) {
    state.sbuList = data;
  },

  setFloatAccountConfig(state, data) {
    state.floatAccountConfig = data;
  },
  setFloatAccountGroup(state, data) {
    state.floatAccountGroup = data;
  },
  setFloatGroupCodeOne(state, data) {
    state.floatGroupCodeOne = data;
  },
  setFloatGroupCodeTwo(state, data) {
    state.floatGroupCodeTwo = data;
  },
  setFloatGroupCodeThree(state, data) {
    state.floatGroupCodeThree = data;
  },
  setFloatGroupCodeFour(state, data) {
    state.floatGroupCodeFour = data;
  },
  setFloatGroupCodeFive(state, data) {
    state.floatGroupCodeFive = data;
  },

  setFloatAccountOne(state, data) {
    state.floatAccountOne = data;
  },
  setFloatAccountTwo(state, data) {
    state.floatAccountTwo = data;
  },
  setFloatAccountThree(state, data) {
    state.floatAccountThree = data;
  },
  setFloatAccountFour(state, data) {
    state.floatAccountFour = data;
  },
  setFloatAccountFive(state, data) {
    state.floatAccountFive = data;
  },

  setFloatAccountCode(state, data) {
    state.floatAccountCode = data;
  },
  setFloatAccountCodeTwo(state, data) {
    state.floatAccountCodeTwo = data;
  },
  setFloatAccountCodeThree(state, data) {
    state.floatAccountCodeThree = data;
  },
  setFloatAccountCodeFour(state, data) {
    state.floatAccountCodeFour = data;
  },
  setFloatAccountCodeFive(state, data) {
    state.floatAccountCodeFive = data;
  },

  setCompanyBoard(state, data) {
    state.companyBoard = data;
  },
  setCompanyBoardCode(state, data) {
    state.companyBoardCode = data;
  },

  setUserLimitPersons(state, data) {
    state.userLimitPersons = data;
  },
  setUserLimitFloatAccountsOne(state, data) {
    state.userLimitFloatAccountsOne = data;
  },
  setUserLimitFloatAccountsTwo(state, data) {
    state.userLimitFloatAccountsTwo = data;
  },
  setUserLimitFloatAccountsThree(state, data) {
    state.userLimitFloatAccountsThree = data;
  },
  setUserLimitFloatAccountsFour(state, data) {
    state.userLimitFloatAccountsFour = data;
  },
  setUserLimitFloatAccountsFive(state, data) {
    state.userLimitFloatAccountsFive = data;
  },

  setPositionInfo(state, data) {
    state.positionInfo = data;
  },
  setPositionCode(state, data) {
    state.positionCode = data;
  },

  setCartableConfirmPriority(state, data) {
    state.cartableConfirmPriority = data;
  },

  setSignatureDetail(state, data) {
    state.signatureDetail = data;
  },

  setImageBrnach(state, data) {
    state.imageBrnach = data;
  },

  setPersonByMobile(state, data) {
    state.personByMobile = data;
  },

  setTransactionInfo(state, data) {
    state.transactionInfo = data;
  },

  setCurrencyTypes(state, data) {
    state.currencyTypes = data;
  },

  setCurrencyTypeCode(state, data) {
    state.currencyTypeCode = data;
  },

  setCurrencyRates(state, data) {
    state.currencyRates = data;
  },

  setVehicleType(state, data) {
    state.vehicleType = data;
  },

  setSuppliers(state, data) {
    state.suppliers = data;
  },
  setSupplier(state, data) {
    state.supplier = data;
  },
  setSupplierByPerson(state, data) {
    state.supplierByPerson = data;
  },

  setBuyers(state, data) {
    state.buyers = data;
  },
  setBuyer(state, data) {
    state.buyer = data;
  },
  setBuyerByPerson(state, data) {
    state.buyerByPerson = data;
  },

  setSmsSetting(state, data) {
    state.smsSetting = data;
  },

  setSettings(state, data) {
    state.settings = data;
  },

  setContractors(state, data) {
    state.contractors = data;
  },

  setBranchesAndOffices(state, data) {
    state.branchesAndOffices = data;
  },
  setBranchesAndOfficesById(state, data) {
    state.branchesAndOfficesById = data;
  },
  setBranchesAndOfficesCode(state, data) {
    state.branchesAndOfficesCode = data;
  },

  setSaleAddMinus(state, data) {
    state.saleAddMinus = data;
  },
  setSaleAddMinusById(state, data) {
    state.saleAddMinusById = data;
  },
  setSaleAddMinusMaxCode(state, data) {
    state.saleAddMinusMaxCode = data;
  },
  setSaleAddMinusPriority(state, data) {
    state.saleAddMinusPriority = data;
  },

  setBuyAddMinuses(state, data) {
    state.buyAddMinuses = data;
  },
  setBuyAddMinus(state, data) {
    state.buyAddMinus = data;
  },
  setBuyAddMinusCode(state, data) {
    state.buyAddMinusCode = data;
  },
  setBuyAddMinusPriority(state, data) {
    state.buyAddMinusPriority = data;
  },
  setBuyAddMinusNavigation(state, data) {
    state.buyAddMinusNavigation = data;
  },
  setBuyAddMinusSearch(state, data) {
    state.buyAddMinusSearch = data;
  },

  setBanks(state, data) {
    state.banks = data;
  },
  setBankMaxCode(state, data) {
    state.bankMaxCode = data;
  },

  setBankBranches(state, data) {
    state.bankBranches = data;
  },
  setBankBranchMaxCode(state, data) {
    state.bankBranchMaxCode = data;
  },
  setBankBranchCode(state, data) {
    state.bankBranchCode = data;
  },

  setDocumentTypes(state, data) {
    state.documentTypes = data;
  },
  setDocumentTypesById(state, data) {
    state.documentTypesById = data;
  },
  setDocumentTypesMaxCode(state, data) {
    state.documentTypesMaxCode = data;
  },

  setCompanies(state, data) {
    state.companies = data;
  },
  setCompany(state, data) {
    state.company = data;
  },

  setUserBranches(state, data) {
    state.userBranches = data;
  },

  setInsuranceType(state, data) {
    state.insuranceType = data;
  },

  setInsuranceTypeById(state, data) {
    state.insuranceTypeById = data;
  },

  setInsuranceTypeCode(state, data) {
    state.insuranceTypeCode = data;
  },

  setEmploymentType(state, data) {
    state.employmentType = data;
  },

  setEmploymentTypeById(state, data) {
    state.employmentTypeById = data;
  },

  setEmploymentTypeCode(state, data) {
    state.employmentTypeCode = data;
  },

  setStudyFieldType(state, data) {
    state.studyFieldType = data;
  },

  setStudyFieldTypeById(state, data) {
    state.studyFieldTypeById = data;
  },

  setStudyFieldTypeCode(state, data) {
    state.studyFieldTypeCode = data;
  },

  setDegree(state, data) {
    state.degree = data;
  },
  setDegreeById(state, data) {
    state.degreeById = data;
  },
  setDegreeCode(state, data) {
    state.degreeCode = data;
  },

  setDepartments(state, data) {
    state.departments = data;
  },
  setDepartmentById(state, data) {
    state.departmentById = data;
  },
  setDepartmentCode(state, data) {
    state.departmentCode = data;
  },

  setPersonnels(state, data) {
    state.personnels = data;
  },
  setPersonnelById(state, data) {
    state.personnelById = data;
  },
  setPersonnelBySearch(state, data) {
    state.personnelBySearch = data;
  },
  setPersonnelCode(state, data) {
    state.personnelCode = data;
  },
  setPersonnelId(state, data) {
    state.personnelId = data;
  },
  setPersonnelNavigation(state, data) {
    state.personnelNavigation = data;
  },

  setServiceCenters(state, data) {
    state.serviceCenters = data;
  },
  setServiceCenterById(state, data) {
    state.serviceCenterById = data;
  },
  setServiceCenterCode(state, data) {
    state.serviceCenterCode = data;
  },

  setUnitCount(state, data) {
    state.unitCount = data;
  },
  setUnitCountCode(state, data) {
    state.unitCountCode = data;
  },

  setVoucherTemplate(state, data) {
    state.voucherTemplate = data;
  },

  setPosTerminals(state, data) {
    state.posTerminals = data || [];
  },
  setPosTerminalTypes(state, data) {
    state.posTerminalTypes = data || [];
  },
  setConnectionTypes(state, data) {
    state.connectionTypes = data || [];
  },

  setBenefitCards(state, data) {
    state.benefitCards = data || [];
  },
  setBenefitCardTypes(state, data) {
    state.benefitCardTypes = data || [];
  },
  setBenefitCardTransactions(state, data) {
    state.benefitCardTransactions = data || [];
  },
  setBenefitCardTransactionTypes(state, data) {
    state.benefitCardTransactionTypes = data || [];
  },
};
